export interface Category {
  id: string;
  name: string;
  slug: string;
  desc: string;
  icon: string;
  cover: string;
}

export const categories: Category[] = [
  {
    id: "xuanhuan",
    name: "玄幻仙侠",
    slug: "玄幻仙侠",
    desc: "御剑飞行、逆天改命，热血沸腾的仙侠世界等你开启。",
    icon: "ri-sword-line",
    cover: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20xianxia%20fantasy%20artwork%2C%20young%20swordsman%20in%20flowing%20white%20robes%20levitating%20above%20misty%20mountain%20peaks%20with%20glowing%20sword%20aura%2C%20dynamic%20comic%20book%20illustration%20style%2C%20dramatic%20warm%20orange%20and%20gold%20lighting%2C%20dark%20background%2C%20cinematic%20energy%20particles%2C%20high%20detail%2C%20vibrant%20colors&width=900&height=1200&seq=cat-xuanhuan&orientation=portrait",
  },
  {
    id: "dushi",
    name: "都市异能",
    slug: "都市异能",
    desc: "穿梭都市与超能之间，逆袭人生从这里开始。",
    icon: "ri-building-2-line",
    cover: "https://readdy.ai/api/search-image?query=Modern%20urban%20superpower%20manhua%20artwork%2C%20cool%20young%20man%20standing%20in%20neon%20city%20street%20at%20night%20with%20electric%20energy%20around%20hands%2C%20dynamic%20comic%20illustration%2C%20teal%20and%20orange%20neon%20glow%2C%20dramatic%20lighting%2C%20high%20detail%2C%20vibrant&width=900&height=1200&seq=cat-dushi&orientation=portrait",
  },
  {
    id: "aiqing",
    name: "甜宠恋爱",
    slug: "甜宠恋爱",
    desc: "甜蜜心动，双向奔赴，每一帧都是撒糖现场。",
    icon: "ri-heart-3-line",
    cover: "https://readdy.ai/api/search-image?query=Cute%20romantic%20couple%20anime%20manhua%20artwork%2C%20boy%20and%20girl%20close%20together%20under%20blossom%20petals%20at%20golden%20sunset%2C%20soft%20warm%20pink%20and%20peach%20tones%2C%20sweet%20romance%20comic%20illustration%2C%20dreamy%20bokeh%2C%20high%20detail&width=900&height=1200&seq=cat-aiqing&orientation=portrait",
  },
  {
    id: "xuanyi",
    name: "悬疑惊悚",
    slug: "悬疑惊悚",
    desc: "层层迷雾、步步惊心，烧脑悬疑一追到底。",
    icon: "ri-mist-line",
    cover: "https://readdy.ai/api/search-image?query=Mystery%20suspense%20manhua%20artwork%2C%20shadowy%20detective%20holding%20a%20magnifying%20glass%20in%20a%20dark%20foggy%20alley%2C%20moody%20mint%20green%20and%20dark%20blue%20lighting%2C%20eerie%20atmosphere%2C%20dynamic%20comic%20illustration%2C%20high%20detail%2C%20cinematic&width=900&height=1200&seq=cat-xuanyi&orientation=portrait",
  },
  {
    id: "xiaoyuan",
    name: "校园青春",
    slug: "校园青春",
    desc: "重返青春校园，那些年悸动与热血的青春物语。",
    icon: "ri-graduation-cap-line",
    cover: "https://readdy.ai/api/search-image?query=Youthful%20school%20campus%20anime%20manhua%20artwork%2C%20students%20in%20school%20uniforms%20under%20cherry%20blossom%20trees%20on%20sunny%20day%2C%20bright%20fresh%20colorful%20palette%2C%20nostalgic%20coming-of-age%20comic%20illustration%2C%20high%20detail%2C%20warm%20sunlight&width=900&height=1200&seq=cat-xiaoyuan&orientation=portrait",
  },
  {
    id: "xianxia",
    name: "逆袭爽文",
    slug: "逆袭爽文",
    desc: "废柴逆袭、一路打脸，看得爽追更不停歇。",
    icon: "ri-flashlight-line",
    cover: "https://readdy.ai/api/search-image?query=Underdog%20revenge%20manhua%20artwork%2C%20determined%20young%20hero%20breaking%20chains%20with%20explosive%20golden%20power%2C%20epic%20battle%20background%2C%20dynamic%20comic%20illustration%2C%20orange%20and%20crimson%20energy%20bursts%2C%20high%20detail%2C%20dramatic%20lighting&width=900&height=1200&seq=cat-nixi&orientation=portrait",
  },
  {
    id: "dongfang",
    name: "东方奇幻",
    slug: "东方奇幻",
    desc: "神话传说与现代想象交织，东方美学视觉盛宴。",
    icon: "ri-sparkling-2-line",
    cover: "https://readdy.ai/api/search-image?query=Oriental%20fantasy%20manhua%20artwork%2C%20mystical%20fox%20spirit%20girl%20in%20traditional%20hanfu%20surrounded%20by%20glowing%20fireflies%20in%20ancient%20forest%2C%20ethereal%20gold%20and%20teal%20lighting%2C%20dynamic%20comic%20illustration%2C%20high%20detail%2C%20magical%20atmosphere&width=900&height=1200&seq=cat-dongfang&orientation=portrait",
  },
];